import * as api from '../resources/privacy-policy.api';
import ationTypes from './privacy-policy.action-types';

export const fetchPrivacyPolicyRequest = () => ({
  type: ationTypes.FETCH_PRIVACY_POLICY_REQUEST,
  name: 'privacyPolicyLoadingStatus',
  hasError: false,
});

export const fetchPrivacyPolicySuccess = (content) => ({
  type: ationTypes.FETCH_PRIVACY_POLICY_SUCCESS,
  name: 'privacyPolicyLoadingStatus',
  hasError: false,
  content,
});

export const fetchPrivacyPolicyFailure = () => ({
  type: ationTypes.FETCH_PRIVACY_POLICY_FAILURE,
  name: 'privacyPolicyLoadingStatus',
  hasError: true,
});

export const fetchPrivacyPolicy = () => async (dispatch) => {
  try {
    dispatch(fetchPrivacyPolicyRequest());
    const { entries } = await api.fetchPrivacyPolicy();
    dispatch(fetchPrivacyPolicySuccess(entries));
  } catch (error) {
    console.error('FETCH_PRIVACY_POLICY', error);
    dispatch(fetchPrivacyPolicyFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/actions/privacy-policy.actions.js